module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"dk":{"passwordChanged":"Adgangskoden blev ændret. Du bliver nu omdirigeret til login-siden...","considerChangingPassword":"<i>Vi har opdateret sikkerheden omkring adgangskoder. For en sikkerheds skyld beder vi dig om at ændre din adgangskode.</i>","currentPassword":"Nuværende adgangskode","newPassword":"Ny Adgangskode","newPasswordRepeat":"Ny Adgangskode (Igen)"}}')
  delete Component.options._Ctor
}
